import React from "react";
import { useAppSelector } from "store/hooks";
import { screenSizeState, userSettingState } from "store/selectors";

export function CustomPagination({
  totalPages,
  currentPage,
  onPageChange: pageChangeFunction,
  classes,
}: any) {
  const { isDarkMode } = useAppSelector(userSettingState);
  const screenSize = useAppSelector(screenSizeState);
  const showPageItemsFunction = () => {
    const data = [];
    const numPage = screenSize <= 768 ? 3 : 5;

    if (totalPages <= numPage) {
      for (let i = 1; i <= totalPages; i++) {
        data.push(
          <button
            key={i}
            onClick={() => pageChangeFunction(i)}
            className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
              i === currentPage
                ? "bg-cyan-900 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            }`}
          >
            {i}
          </button>
        );
      }
    } else {
      const leftside = currentPage - numPage / 2 > 1;
      const rightside = currentPage + numPage / 2 < totalPages;

      // First and Previous buttons
      data.push(
        <button
          key="first"
          onClick={() => pageChangeFunction(1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
            currentPage === 1
              ? "cursor-not-allowed bg-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-200"
          }`}
        >
          &lt;&lt;
        </button>
      );

      data.push(
        <button
          key="prev"
          onClick={() => pageChangeFunction(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
            currentPage === 1
              ? "cursor-not-allowed bg-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-200"
          }`}
        >
          &lt;
        </button>
      );

      if (leftside) {
        data.push(
          <span key="leftEllipsis" className="px-3 py-1 mx-1 text-gray-500">
            ...
          </span>
        );
      }

      const str = Math.max(1, Math.round(currentPage - numPage / 2));
      const end = Math.min(totalPages, Math.round(currentPage + numPage / 2));

      for (let i = str; i <= end; i++) {
        data.push(
          <button
            key={i}
            onClick={() => pageChangeFunction(i)}
            className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
              i === currentPage
                ? "bg-cyan-900 text-white"
                : "bg-white text-gray-700 hover:bg-gray-200"
            }`}
          >
            {i}
          </button>
        );
      }

      if (rightside) {
        data.push(
          <span key="rightEllipsis" className="px-3 py-1 mx-1 text-gray-500">
            ...
          </span>
        );
      }

      // Next and Last buttons
      data.push(
        <button
          key="next"
          onClick={() => pageChangeFunction(currentPage + 1)}
          disabled={totalPages === currentPage}
          className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
            totalPages === currentPage
              ? "cursor-not-allowed bg-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-200"
          }`}
        >
          &gt;
        </button>
      );

      data.push(
        <button
          key="last"
          onClick={() => pageChangeFunction(totalPages)}
          disabled={totalPages === currentPage}
          className={`px-3 py-1 border border-cyan-900 rounded mx-1 ${
            totalPages === currentPage
              ? "cursor-not-allowed bg-gray-200"
              : "bg-white text-gray-700 hover:bg-gray-200"
          }`}
        >
          &gt;&gt;
        </button>
      );
    }

    return data;
  };

  return (
    <div className={`flex justify-center my-3 sm:my-8  ${classes}`}>
      <div
        className={`flex flex-wrap md:flex-nowrap justify-center md:justify-start items-center space-x-1 ${
          isDarkMode ? "bg-darkPrimary" : "bg-white"
        } w-fit p-2 rounded-md shadow-md`}
      >
        {showPageItemsFunction()}
      </div>
    </div>
  );
}
